module.exports = __webpack_public_path__ + "static/media/questionnaire.02cce4a7.jpg";